import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    CardActions,
    CircularProgress,
    IconButton,
    makeStyles,
    Slider,
} from "@material-ui/core";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TOM_CONTENT_TYPES, TOM_REPORT_TYPES } from "../constants";
import CloseIcon from "@material-ui/icons/Close";
import CriticalIcon from "@material-ui/icons/HighlightOff";
import WarningIcon from "@material-ui/icons/ErrorOutline";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import FsLightbox from "fslightbox-react";
import { useBooleanState } from "../../../utils/hooks/useBooleanState";
import { Button, Input } from "../../root/components/common";
import { useMakeReport } from "../hooks/useMakeReport";
import { OPERATION_MODES } from "../../root/constants";



export const ReportForm = ({
    pictureData,
    onClose,
    formState,
    onSubmit,
    type,
    queryKey
}) => {
    const { locale } = useSelector((store) => store.main);
    const { device } = pictureData;
    const SNAPTRAP = [
        {
            name: locale.tom.mouse,
            type: "mouse",
            imageUri: require("../../../assets/img/tom/maus.png"),
            steps: [0, 1, 2, 3],
        },
        {
            name: locale.tom.rat,
            type: "rat",
            imageUri: require("../../../assets/img/tom/ratte.png"),
            steps: [0, 1, 2, 3],
        },
    ];

    const INSECT_MODE = [
        {
            name: locale.tom.bedbug,
            type: "bedbug",
            imageUri: require("../../../assets/img/tom/wanze.png"),
            steps: [0, 5, 10, 15, 20, 25, 30],
        },
        {
            name: locale.tom.ant,
            type: "ant",
            imageUri: require("../../../assets/img/tom/ameise.png"),
            steps: [0, 5, 10, 15, 20, 25, 30],
        },
        {
            name: locale.tom.roach,
            type: "roach",
            imageUri: require("../../../assets/img/tom/schabe.png"),
            steps: [0, 5, 10, 15, 20, 25, 30],
        },
        {
            name: locale.tom.moth,
            type: "moth",
            imageUri: require("../../../assets/img/tom/motte.png"),
            steps: [0, 5, 10, 15, 20, 25, 30],
        },
        {
            name: locale.tom.cockroach,
            type: "cockroach",
            imageUri: require("../../../assets/img/tom/kakerlake.png"),
            steps: [0, 5, 10, 15, 20, 25, 30],
        },
        {
            name: locale.tom.fly,
            type: "fly",
            imageUri: require("../../../assets/img/tom/fliege.png"),
            steps: [0, 5, 10, 15, 20, 25, 30],
        },
        {
            name: locale.tom.other,
            type: "other",
            imageUri: require("../../../assets/img/tom/andere.png"),
            steps: [0, 5, 10, 15, 20, 25, 30],
        },
    ];
    const isInsectMode = device.operation_mode === "insect";
    const options =
        isInsectMode ? INSECT_MODE : SNAPTRAP;
    const [state, setState] = useState(formState || {});
    const [triggerMode, setTriggerMode] = useState(null);
    const [comment, setComment] = React.useState("");
    const lightbox = useBooleanState(false);
    const [openedListItem, setOpenedListItem] = useState(null);

    const { isLoading, mutateAsync } = useMakeReport(queryKey);

    const handleSubmit = async () => {
        await mutateAsync({
            id: pictureData.id,
            body: getBody(pictureData, state, options, triggerMode, type, comment),
            deviceId: pictureData.device_id
        });
        onSubmit(pictureData.id)
    };

    const isSelectTriggerMode =
        device.operation_mode === OPERATION_MODES.snaptrap &&
        type === "warning" &&
        (!triggerMode || triggerMode === "falseTrigger");

    const photoUrl = "data:image/jpeg;base64," + pictureData.file;

    const useStyles = makeStyles((theme) => ({
        root: {
            flex: 1,
            minWidth: 720,
            minHeight: 450,
        },
        header: {
            height: 56,
            position: "relative",
            padding: 8,
            flexDirection: "row",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: type === "critical" ? theme.error : theme.warning,
        },
        closeBtn: {
            position: "absolute",
            right: 8,
        },
        headerTitle: {
            cursor: "default",
            flexDirection: "row",
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
            "&& > div": {
                color: "#FFF",
                fontWeight: "bold",
                fontSize: 14,
                marginRight: 8,
            },
        },
        img: {
            borderRadius: "4px",
            width: 350,
            cursor: "pointer",
        },
        content: {
            padding: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
        },
        formContainer: {
            width: "100%",
            padding: 8,
            marginTop: 16,
        },
        actionButtons: {
            marginTop: "auto",
            justifyContent: "flex-end",
        },
        itemImage: {
            width: 40,
            height: 40,
            marginRight: 32,
        },

        headerEnd: {
            backgroundColor: theme.primary,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 24,
            minWidth: 24,
            padding: 4,
            borderRadius: 24,
            marginLeft: "auto",
            fontSize: 13,
            color: "#FFF",
        },
        listItemHeader: {
            alignItems: "center",
        },
        accordeonDetails: {
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            width: "80%",
        },
        accordeonRoot: {
            display: "flex",
            justifyContent: "center",
        },
        inputStyle: {
            position: "relative",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            maxWidth: 60,
        },
        comment: {
            marginTop: 16,
        },
    }));
    const cls = useStyles();

    const isValid = () => {
        const stateValid = Object.values(state).some(Boolean);
        if (comment) {
            return true
        }
        if (triggerMode) {
            if (triggerMode === "triggered") {
                return stateValid
            }
            return true
        }
        return Object.values(state).length > 0 && stateValid
    }


    return (
        <div className={cls.root}>
            <div className={cls.header}>
                <div className={cls.headerTitle}>
                    <div>{locale.tom[type].toUpperCase()}</div>
                    {type === "critical" ? (
                        <CriticalIcon htmlColor="#fff" />
                    ) : (
                        <WarningIcon htmlColor="#fff" />
                    )}
                </div>
                <IconButton
                    onClick={onClose}
                    className={cls.closeBtn}
                    aria-label="close"
                >
                    <CloseIcon htmlColor="#fff" />
                </IconButton>
            </div>
            <div className={cls.content}>
                <div>
                    <FsLightbox toggler={lightbox.is} sources={[photoUrl]} />
                    <img onClick={lightbox.toggle} className={cls.img} src={photoUrl} />
                </div>
                <div className={cls.formContainer}>
                    {isSelectTriggerMode && (
                        <TriggerModeSelect
                            locale={locale}
                            value={triggerMode}
                            onChangeMode={setTriggerMode}
                        />
                    )}
                    {!isSelectTriggerMode &&
                        options.map(({ name, imageUri, steps }, i) => {
                            const isExpanded = i === openedListItem;

                            return (
                                <Accordion
                                    key={name}
                                    expanded={isExpanded}
                                    onChange={() =>
                                        setOpenedListItem(openedListItem === i ? null : i)
                                    }
                                >
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        classes={{ content: cls.listItemHeader }}
                                    >
                                        <img src={imageUri} className={cls.itemImage} />
                                        <div>{name}</div>
                                        {!isExpanded && Boolean(state[i]) && (
                                            <div className={cls.headerEnd}>{state[i]}</div>
                                        )}
                                    </AccordionSummary>
                                    <AccordionDetails classes={{ root: cls.accordeonRoot }}>
                                        <div className={cls.accordeonDetails}>
                                            <div className={cls.inputStyle}>
                                                <Input
                                                    onKeyPress={(event) => {
                                                        if (!/[0-9]/.test(event.key)) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                    onBlur={() => {
                                                        if (state[i] < 0) {
                                                            setValue(0);
                                                        }
                                                    }}
                                                    inputProps={{ maxLength: isInsectMode ? 4 : 2 }}
                                                    defaultValue={0}
                                                    value={state[i] || 0}
                                                    setValue={(newValue) => {
                                                        setState({ ...state, [i]: Number(newValue) })
                                                    }}
                                                />
                                            </div>
                                            {(state[i] || 0) <= steps[steps.length - 1] && (
                                                <Slider
                                                    value={Number(state[i]) || 0}
                                                    onChange={(e, newValue) =>
                                                        setState({ ...state, [i]: newValue })
                                                    }
                                                    marks={steps.map((i) => ({
                                                        value: i,
                                                        label: `${i}`,
                                                    }))}
                                                    min={0}
                                                    max={steps[steps.length - 1]}
                                                    step={steps[1]}
                                                />
                                            )}
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                            );
                        })}
                    {!isSelectTriggerMode && (
                        <Input
                            label={locale.tom.comments}
                            className={cls.comment}
                            value={comment}
                            setValue={setComment}
                            multiline
                        />
                    )}
                </div>
            </div>
            <CardActions className={cls.actionButtons}>
                <Button reverted onClick={onClose}>
                    {locale.common.cancel}
                </Button>
                <Button disabled={!isValid() || isLoading} onClick={handleSubmit}>
                    {isLoading ? <CircularProgress size={24} color="inherit" /> : locale.common.submit}
                </Button>
            </CardActions>
        </div>
    );
};

const TriggerModeSelect = ({ value, onChangeMode, locale }) => {
    const useStyles = makeStyles((theme) => ({
        col: {
            justifyContent: "center",
            height: "100%",
            alignItems: "center",
            display: "flex",
            flex: 1,
        },
        container: {
            height: 64,
            border: `1px solid ${theme.primaryHover}`,
            padding: 8,
            borderRadius: 8,
            cursor: "pointer",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
        },
        active: {
            marginTop: 16,
            backgroundColor: value === "falseTrigger" && theme.secondary,
        },
        wrapper: {
            width: "60%",
        },
    }));
    const cls = useStyles();

    return (
        <div className={cls.col}>
            <div className={cls.wrapper}>
                <div onClick={() => onChangeMode("triggered")}>
                    <div className={cls.container}>
                        <div>{locale.tom.activity}</div>
                    </div>
                </div>
                <div onClick={() => onChangeMode("falseTrigger")}>
                    <div className={`${cls.container} ${cls.active}`}>
                        <div>{locale.tom.falseTrigger}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const getBody = (pictureData, state, options, triggerMode, type, comment) => {
    const mode = pictureData.device.operation_mode;

    const { contentType, amount } = getInfestationAmount(state, options);

    if (mode === OPERATION_MODES.snaptrap) {
        return {
            operation_mode: mode,
            content_type: contentType,
            infestation_amount: amount,
            report_type:
                type === "warning"
                    ? triggerMode === "falseTrigger"
                        ? TOM_REPORT_TYPES.false_trigger
                        : TOM_REPORT_TYPES.activity_warning
                    : TOM_REPORT_TYPES.infested,
            comment,
        };
    }
    if (mode === "movement") {
        return {
            operation_mode: mode,
            content_type: contentType,
            infestation_amount: amount,
            report_type:
                type === "warning"
                    ? TOM_REPORT_TYPES.activity_warning
                    : TOM_REPORT_TYPES.activity_critical,
            comment,
        };
    }
    if (mode === "insect") {
        return {
            operation_mode: mode,
            content_type: contentType,
            infestation_amount: amount,
            report_type:
                type === "warning"
                    ? TOM_REPORT_TYPES.light_infestation
                    : TOM_REPORT_TYPES.severe_infestation,
            comment,
        };
    }
};

const getInfestationAmount = (state, options) => {
    const contentId = Object.keys(state).length - 1;
    if (contentId < 0) {
        return {
            contentType: TOM_CONTENT_TYPES.empty,
            amount: null,
        };
    }
    const lastContentAmount = Object.keys(state)[contentId];

    const amount = `${state[lastContentAmount]}` || null;
    const type = options[lastContentAmount].type || TOM_CONTENT_TYPES.empty;

    return {
        contentType: type,
        amount,
    };
};
